import { useRef } from "react";
import { CATEGORY_GENERAL2_NAME_LIST } from "../../../lib/const";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

  
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );



export const SummaryCategory = ({category})=>{
    const chartRef = useRef(null);
    let categoryValues = new Array(CATEGORY_GENERAL2_NAME_LIST.length).fill(0);
    let categoriesLabel = [...CATEGORY_GENERAL2_NAME_LIST];
    // console.log(readingYearHistory.summary.category_general2);


    category.map((item)=>{
        categoryValues[item.name] = item.value;
        return null;
    });


    categoriesLabel.forEach((label, idx, arr) => {
        arr[idx] = `${label}: ${categoryValues[idx]}`;
    });

    
    const categoryChartData = {
        labels: categoriesLabel,
        datasets: [{
            data: categoryValues,
            backgroundColor: [ '#ede264', '#DFFF00', '#FFBF00', '#FF7F50', '#DE3163',  '#9FE2BF',
                            '#71ed64', '#40E0D0', '#fff600',  '#6495ED', '#9b64ed',  '#CCCCFF' ],
            hoverBackgroundColor: [ '#ede264', '#DFFF00', '#FFBF00', '#FF7F50', '#DE3163',  '#9FE2BF',
                                    '#71ed64', '#40E0D0', '#fff600',  '#6495ED', '#9b64ed',  '#CCCCFF' ]
        }]
    };


    return (
        <div className="col12 box reading_status">
            <h3><span className="icon05">독서현황</span></h3>
            <div className="chart">
            <Bar ref={chartRef}
                width={800}
                options={{
                    responsive:true,
                    maintainAspectRatio:true,
                    plugins:{
                        legend:false
                    },
                    scales: {
                        y:{
                            stacked: true,
                            ticks: { precision: 0, stepSize:50}
                        }
                    }
                }}
                data={categoryChartData}
                legend={{display:false}}  />
            </div>
        </div>
    );
}// end